import { Link } from 'react-router';

import SearchResultsTable from 'components/SearchResultsTable/SearchResultsTable';

const columns = [
  {
    title: 'First Name',
    dataIndex: 'firstName',
    key: 'firstName',
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
    key: 'lastName',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (email, customer) => {
      if (email && customer) {
        return <Link to={`/customers/${customer.customerId}`}>{email}</Link>;
      }
    },
  },
  {
    title: 'Last Four SSN',
    dataIndex: 'ssn',
    key: 'ssn',
    align: 'right',
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
  },
  {
    title: 'Local Time',
    dataIndex: 'localTime',
    key: 'localTime',
  },
];

const CustomerSearchResults = ({
  loading,
  onPageChange,
  page,
  searchResults,
  emptyText,
}) => {
  return (
    <SearchResultsTable
      columns={columns}
      data={searchResults}
      loading={loading}
      emptyText={emptyText || 'No customers found'}
      pagination={{
        current: page || undefined,
        onChange: onPageChange,
      }}
    />
  );
};

export default CustomerSearchResults;
